import { render, staticRenderFns } from "./interview-form.vue?vue&type=template&id=0238fb46&scoped=true"
import script from "./interview-form.vue?vue&type=script&lang=js"
export * from "./interview-form.vue?vue&type=script&lang=js"
import style0 from "./interview-form.vue?vue&type=style&index=0&id=0238fb46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0238fb46",
  null
  
)

export default component.exports